import SelectInput, { DynamicOption } from "components/fields/SelectInput";

interface ProjectCountersFilterProps {
  tagSelect: DynamicOption[] | null;
  sortValueSelect: DynamicOption[] | null;
  reversedSelect: DynamicOption[] | null;
  countSelect: DynamicOption[] | null;
  counterUnitSelect: DynamicOption[] | null;
  sortValue: DynamicOption | null;
  setSortValue: React.Dispatch<any>;
  tag: DynamicOption | null;
  setTag: React.Dispatch<any>;
  reversed: DynamicOption | null;
  setReversed: React.Dispatch<any>;
  unitFilter: DynamicOption;
  setUnitFilter: React.Dispatch<any>;
  searchName: string;
  setSearchName: React.Dispatch<any>;
}
const ProjectCountersFilter = (props: ProjectCountersFilterProps) => {
  const {
    sortValueSelect,
    tagSelect,
    reversedSelect,
    counterUnitSelect,
    sortValue,
    setSortValue,
    tag,
    setTag,
    reversed,
    setReversed,
    unitFilter,
    setUnitFilter,
    searchName,
    setSearchName,
  } = props;

  return (
    <div className={`grid grid-cols-1 gap-4 md:grid-cols-4  `}>
      <SelectInput
        label="دسته بندی"
        placeholder="دسته بندی مورد نظر را انتخاب کنید"
        dynamicOptions={tagSelect}
        state={tag}
        setState={setTag}
        isMandatory={true}
      />
      <SelectInput
        label="اولویت نمایش"
        placeholder="اولویت نمایش را انتخاب کنید"
        dynamicOptions={sortValueSelect}
        state={sortValue}
        setState={setSortValue}
        isMandatory={true}
      />

      <SelectInput
        label="نحوه نمایش"
        placeholder="نحوه نمایش مورد نظر را انتخاب کنید"
        dynamicOptions={reversedSelect}
        state={reversed}
        setState={setReversed}
        isMandatory={true}
      />
      <SelectInput
        label="واحد"
        placeholder="واحد مورد نظر را انتخاب کنید"
        dynamicOptions={counterUnitSelect}
        state={unitFilter}
        setState={setUnitFilter}
        isMandatory={true}
      />
      <div className="mx-2">
        <label className="ml-3 text-sm font-bold text-navy-700 dark:text-white">
          جستجو نام کنتور
        </label>
        <input
          type="text"
          placeholder="نام کنتور را وارد کنید"
          value={searchName}
          onChange={(e) => setSearchName(e.target.value)}
          className="basic-single mt-2 w-full rounded-md border px-3 py-2 text-sm focus:outline-none focus:ring focus:ring-blue-300 dark:text-white"
        />
      </div>
    </div>
  );
};
export default ProjectCountersFilter;
